import React from 'react';
import styled from '@emotion/styled';
import { Card, Divider, Heading } from '../../common';
import { getActiveChapter, timeToSeconds } from './chapterLayouts';

const Panel = styled(Card)`
  background: var(--midWhite);
  padding: 0;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: ${props => (props.fill ? '1 1 auto' : '0 0 auto')};
  margin-bottom: ${props => (props.fill ? '0' : '0.75rem')};
  max-height: ${props => (props.fill ? 'none' : '18rem')};
`;

const List = styled.div`
  overflow-y: auto;
  min-height: 0;
  flex: 1 1 auto;
  padding: 8px;
`;

const Item = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  border: 1px solid ${props => (props.active ? 'var(--sapGreen)' : '#e6eaed')};
  background: ${props => (props.active ? '#e8f4fd' : '#fff')};
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 8px;
  cursor: pointer;

  .stamp {
    font-size: 16px;
    font-weight: 700;
    color: ${props => (props.active ? 'var(--sapGreen)' : '#38454f')};
    margin: 0 0 4px 0;
  }

  .title {
    font-size: 12px;
    font-weight: 600;
    color: #38454f;
    margin: 0 0 8px 0;
  }
`;

const Range = styled.div`
  height: 4px;
  width: 100%;
  background: #e6eaed;
  border-radius: 2px;
  overflow: hidden;

  span {
    display: block;
    height: 100%;
    width: ${props => props.width};
    background: var(--sapGreen);
  }
`;

export default function ChapterCards({
  chapters = [],
  currentTime = '',
  onChapterClick = () => {},
  fill = false
}) {
  const activeChapter = getActiveChapter(chapters, currentTime);

  return (
    <Panel fill={fill}>
      <Heading
        type={3}
        className="p-3 mb-0 pb-0"
        fontSize="10px"
        fontWeight="400"
        color="var(--seaBlue)"
        style={{ lineHeight: '14px', letterSpacing: '0.15rem', textTransform: 'uppercase' }}
      >
        chapters
      </Heading>
      <Divider background="var(--lightGrey)" height="2px" width="100%" margin="8px 0 0" />
      <List>
        {chapters.length ? (
          chapters.map((section, index) => {
            const isActive = activeChapter?.label === section.label;
            const start = timeToSeconds(section.start);
            const end = timeToSeconds(section.end);
            const current = timeToSeconds(currentTime);
            const span = Math.max(end - start, 1);
            const progress = isActive ? Math.min(100, Math.max(0, ((current - start) / span) * 100)) : 0;

            return (
              <Item
                key={`${section.label}-${index}`}
                type="button"
                active={isActive}
                onClick={() => onChapterClick(section)}
              >
                <p className="stamp">{section.start}</p>
                <p className="title">
                  {index + 1}. {section.label}
                </p>
                <Range width={`${progress}%`}>
                  <span />
                </Range>
              </Item>
            );
          })
        ) : (
          <div style={{ padding: '12px', fontSize: '12px', color: '#6b7780' }}>No chapters found.</div>
        )}
      </List>
    </Panel>
  );
}
